<template>
  <div 
    class="mt-8">
      <v-dialog v-model="dialog.status"
            @keydown.esc="dialog.status = false"
            :fullscreen="dialog.fullscreen"
            width="500"
            persistent
            scrollable>
            <v-card 
              :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius-card'"
              class="pa-8 pt-6">
              <v-card-title 
                class="d-flex align-center pa-0 pb-4 text-right popup-header fs-20 font-weight-bold">
                
                Mengubah Status
  
                <v-spacer/>
  
                <!-- <v-icon 
                  @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                  class="cursor-pointer mr-1"
                  size="24"
                  color="#718EBF">
                  {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
                </v-icon>
  
                <v-icon 
                  @click="dialog.status = false; dialog.fullscreen = false; selected.status = [];"
                  class="cursor-pointer"
                  size="24"
                  color="red">
                  mdi-close-circle-outline
                </v-icon> -->
  
                <v-icon 
                  @click="dialog.status = false; dialog.fullscreen = false; message.status = ''; message.error = ''"
                  class="cursor-pointer"
                  size="18"
                  color="#000000">
                  mdi-close
                </v-icon>
              </v-card-title>
              
              <!-- <v-divider 
                class="mb-2"
                style="border-top: 2px dashed #e0e0e0;"/> -->
  
              <v-card-text 
                class="body-1 font-weight-light text-first line-text-second my-0 px-0 py-3">
                Apakah Anda yakin mengubah status data ?

                <v-autocomplete
                  v-if="detail.status === 'diterima driver' || detail.status === 'Set Order'"
                  v-model="status"
                  :items="['diterima driver', 'pengiriman']"
                  
                  label="Pilih Status"
                  multiple
                  dense
                  outlined
                  hide-details
                  style="width: 100%"
                  class="mt-4"
                  >
                </v-autocomplete>

  
                <div v-if="message.error.length > 0"
                  class="text-left mt-4">
                  <div
                    class="error--text d-flex align-start">
                    <v-icon size="18" color="red" style="padding-top: 5px;">mdi-alert-circle-outline</v-icon>
                    
                    <span
                      class="ml-1">
                      {{ message.error }}
                    </span>
                  </div>
                </div>
              </v-card-text>
  
  
              <!-- <v-divider 
                class="mt-2"
                style="border-top: 2px dashed #e0e0e0;"/> -->
  
              <v-card-actions
                class="pa-0 pt-4">
                <v-spacer/>
  
                <v-btn
                  rounded
                  @click="save()"
                  :loading="process.form"
                  :disabled="process.form"
                  width="190"
                  height="45"
                  elevation="0"
                  color="#1814F3"
                  class="fs-16 white--text text-capitalize border-radius">
                  Ya, {{ message.status }}
                </v-btn>
  
                <!-- <v-btn
                  rounded
                  width="120"
                  @click="dialog.status = false; dialog.fullscreen = false; selected.status = [];"
                  :disabled="process.status"
                  outlined
                  class="body-2 font-weight-bold text-capitalize red--text">
                  Batal
                </v-btn> -->
              </v-card-actions>
            </v-card>
          </v-dialog>
    <v-layout wrap>
      <v-flex>
        <section>
          <v-card 
            flat
            class="ma-4 mt-0 box-shadow pb-5"
            style="border-radius: 10px;">

            <v-row
              class="pa-4 py-0">
              <v-col
                cols="12"
                class="pb-0"
                md="7">
                <span
                  class="fs-16 black--text"
                  style="font-weight: 600;">
                  Detail BPB
                </span>
              </v-col>

              <v-col
                cols="12"
                md="12"
                class="d-flex align-center py-0">
                <v-row>
                  <v-col cols="12" md="7">
                    <table style="width: auto;" class="mb-2" v-if="!process.load && Object.keys(detail).length > 0">
                      <!-- <tr>
                        <td class="fs-12">
                          Kode Konsumen
                        </td>
                        <td style="width: 40px" class="fs-12 text-center pb-2">
                          : 
                        </td>
                        <td class="text-left font-weight-bold fs-12">
                          {{ detail.customer_code }}
                        </td>
                      </tr> -->
                      <tr>
                        <td class="fs-12">
                          Nama Toko
                        </td>
                        <td style="width: 40px" class="fs-12 text-center pb-2">
                          : 
                        </td>
                        <td class="text-left font-weight-bold fs-12">
                          {{ detail.store_name }}
                        </td>
                      </tr>
                      <tr>
                        <td class="fs-12">
                          Nama Pemilik
                        </td>
                        <td style="width: 40px" class="fs-12 text-center pb-2">
                          : 
                        </td>
                        <td class="text-left font-weight-bold fs-12">
                          <a target="_blank" :href="`/customer/data/detail/${detail.customer_id}`">
                            {{ detail.customer_name }}
                          </a>
                        </td>
                      </tr>
                      <tr>
                        <td class="fs-12">
                          Term Of Payment
                        </td>
                        <td style="width: 40px" class="fs-12 text-center pb-2">
                          : 
                        </td>
                        <td class="text-left font-weight-bold fs-12">
                          {{ detail.customer_term }} Hari
                        </td>
                      </tr>
                      <tr>
                        <td class="fs-12">
                          Alamat
                        </td>
                        <td style="width: 40px" class="fs-12 text-center pb-2">
                          : 
                        </td>
                        <td class="text-left font-weight-bold fs-12">
                          {{ detail.customer_shipping_city }}, {{ detail.customer_shipping_province }}, {{ detail.customer_shipping_subdistrict }}, {{ detail.customer_shipping_village }}
                        </td>
                      </tr>
                      <tr>
                        <td class="fs-12">
                          PDF
                        </td>
                        <td style="width: 40px" class="fs-12 text-center pb-2">
                          : 
                        </td>
                        <td class="text-left font-weight-bold fs-12 pt-2">
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                @click="exports(detail.id)"
                                :loading="process.export"
                                :disabled="process.export"
                                elevation="0"
                                min-height="28"
                                small
                                min-width="28"
                                color="#bd1112"
                                class="text-capitalize white--text"
                                style="border-radius: 6px;"
                                v-bind="attrs"
                                v-on="on">
                                <v-icon size="18" color="white" class="mr-2">mdi-file-pdf-box</v-icon> Download
                              </v-btn>
                            </template>

                            <span>
                              Export Pdf
                            </span>
                          </v-tooltip>
                        </td>
                      </tr>
                    </table>
                  </v-col>
                  <v-col cols="12" md="5">
                    <table style="width: auto;" class="mb-2" v-if="!process.load && Object.keys(detail).length > 0">
                      <tr>
                        <td class="fs-12">
                          No. BPB
                        </td>
                        <td style="width: 40px" class="fs-12 text-center pb-2">
                          : 
                        </td>
                        <td class="text-left font-weight-bold fs-12">
                          {{ detail.number }}
                        </td>
                      </tr>
                      <tr>
                        <td class="fs-12">
                          Status BPB
                        </td>
                        <td style="width: 40px" class="fs-12 text-center pb-2">
                          : 
                        </td>
                        <td class="text-left font-weight-bold fs-12">
                          {{ detail.is_delivery === '0' ? 'Belum Diproses' : 'Sudah Diproses' }}
                        </td>
                      </tr>
                      <tr>
                        <td class="fs-12">
                          No. Order
                        </td>
                        <td style="width: 40px" class="fs-12 text-center pb-2">
                          : 
                        </td>
                        <td class="text-left font-weight-bold fs-12">
                          {{ detail.order_number }}
                        </td>
                      </tr>
                      <tr>
                        <td class="fs-12">
                          Tanggal Order
                        </td>
                        <td style="width: 40px" class="fs-12 text-center pb-2">
                          : 
                        </td>
                        <td class="text-left font-weight-bold fs-12">
                          {{ detail.order_input_datetime | datetime }}
                        </td>
                      </tr>
                      <tr>
                        <td class="fs-12">
                          Nama Sales
                        </td>
                        <td style="width: 40px" class="fs-12 text-center pb-2">
                          : 
                        </td>
                        <td class="text-left font-weight-bold fs-12">
                          {{ detail.sales_name }}
                        </td>
                      </tr>
                    </table>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>

            <v-card 
                flat
                class="mt-0 mx-5"
                style="border-radius: 25px; border: 1px solid #E7E7E7;">
                <!-- :height="`calc(100vh - ${pagination.total_data > 0 ? '320px' : '148px'})`" -->
                <div class="view">
                  <div v-if="!process.load" :class="process.load || varian.length === 0 ? '' : 'wrapper-laporan-faktur'">
                    <table style="border-radius: 10px; width: 100%;" class="table">
                      <tr>
                        <th class="sticky-col one-col" style="z-index: 2; font-size: 12px; border: 1px solid #ededed; border-left: none; width: 1px; white-space: nowrap; padding: 8px 12px; text-align: center;">
                          Nama Varian
                        </th>
                        <th style="font-size: 12px; z-index: 1; border: 1px solid #ededed; padding: 8px 12px; padding-right: 50px; width: 1px; white-space: nowrap; text-align: left;">
                          Kode SKU
                        </th>
                        <th style="font-size: 12px; z-index: 1; border: 1px solid #ededed; padding: 8px 12px; padding-right: 50px; width: 1px; white-space: nowrap; text-align: left;">
                          Dikirim
                        </th>
                        <th style="font-size: 12px; z-index: 1; border: 1px solid #ededed; padding: 8px 12px; padding-right: 50px; width: 1px; white-space: nowrap; text-align: left;">
                          Diterima
                        </th>
                        <th style="font-size: 12px; z-index: 1; border: 1px solid #ededed; padding: 8px 12px; padding-right: 50px; width: 1px; white-space: nowrap; text-align: left;">
                          Dikembalikan
                        </th>
                        <th style="font-size: 12px; z-index: 1; border: 1px solid #ededed; padding: 8px 12px; padding-right: 50px; width: 1px; white-space: nowrap; text-align: left;">
                          Rusak
                        </th>
                        <th style="font-size: 12px; z-index: 1; border: 1px solid #ededed; padding: 8px 12px; padding-right: 50px; width: 1px; white-space: nowrap; text-align: left;">
                          Rusak Setelah Kirim
                        </th>
                      </tr>
                      <tr v-for="(item, index) in varian" :key="index" @click="selected.row = index" :class="selected.row === index ? 'selected' : ''">
                        <td class="sticky-col one-col" style="z-index: 2; font-size: 12px; border: 1px solid #ededed; border-left: none; width: 1px; white-space: nowrap; padding: 8px 12px; text-align: center;">
                          {{ item.varian_name}}
                        </td>
                        <td style="font-size: 12px; border: 1px solid #ededed; padding: 8px 12px; padding-right: 50px; width: 1px; white-space: nowrap; text-align: left;">
                          {{ item.varian_sku }}
                        </td>
                        <td style="font-size: 12px; border: 1px solid #ededed; padding: 8px 12px; padding-right: 50px; width: 1px; white-space: nowrap; text-align: left;">
                          <div v-if="item.qty_pcs*1 > 0">
                            {{ item.qty_pcs }} Pcs
                          </div>
                          <div v-if="item.qty_lusin*1 > 0">
                            {{ item.qty_lusin }} Lusin
                          </div>
                          <div v-if="item.qty_dus*1 > 0">
                            {{ item.qty_dus | number }} {{ (item.varian_total_in_dus*1) > 1 ? 'Dus' : 'Pcs' }}
                          </div>
                        </td>
                        <td style="font-size: 12px; border: 1px solid #ededed; padding: 8px 12px; padding-right: 50px; width: 1px; white-space: nowrap; text-align: left;">
                          <div v-if="(item.qty_pcs_diterima*1) > 0">
                            {{ item.qty_pcs_diterima }} Pcs
                          </div>
                          <div v-if="item.qty_lusin_diterima*1 > 0">
                            {{ item.qty_lusin_diterima }} Lusin
                          </div>
                          <div v-if="(item.qty_dus_diterima*1) > 0">
                            {{ item.qty_dus_diterima | number }} {{ (item.varian_total_in_dus*1) > 1 ? 'Dus' : 'Pcs' }}
                          </div>
                          <div v-if="item.qty_pcs_diterima*1 === 0 && item.qty_lusin_diterima*1 === 0 && item.qty_dus_diterima*1 === 0">
                            -
                          </div>
                        </td>
                        <td style="font-size: 12px; border: 1px solid #ededed; padding: 8px 12px; padding-right: 50px; width: 1px; white-space: nowrap; text-align: left;">
                          <div v-if="item.qty_pcs_return*1 > 0">
                            {{ item.qty_pcs_return }} Pcs
                          </div>
                          <div v-if="item.qty_lusin_return*1 > 0">
                            {{ item.qty_lusin_return }} Lusin
                          </div>
                          <div v-if="item.qty_dus_return*1 > 0">
                            {{ item.qty_dus_return | number }} {{ (item.varian_total_in_dus*1) > 1 ? 'Dus' : 'Pcs' }}
                          </div>
                          <div v-if="item.qty_pcs_return*1 === 0 && item.qty_lusin_return*1 === 0 && item.qty_dus_return*1 === 0">
                            -
                          </div>
                        </td>
                        <td style="font-size: 12px; border: 1px solid #ededed; padding: 8px 12px; padding-right: 50px; width: 1px; white-space: nowrap; text-align: left;">
                          <div v-if="item.qty_pcs_rusak*1 > 0">
                            {{ item.qty_pcs_rusak }} Pcs
                          </div>
                          <div v-if="item.qty_lusin_rusak*1 > 0">
                            {{ item.qty_lusin_rusak }} Lusin
                          </div>
                          <div v-if="item.qty_dus_rusak*1 > 0">
                            {{ item.qty_dus_rusak | number }} {{ (item.varian_total_in_dus*1) > 1 ? 'Dus' : 'Pcs' }}
                          </div>
                          <div v-if="item.qty_dus_rusak*1 === 0">
                            -
                          </div>
                        </td>
                        <td style="font-size: 12px; border: 1px solid #ededed; padding: 8px 12px; padding-right: 50px; width: 1px; white-space: nowrap; text-align: left;">
                          <div>
                            {{ item.kirim_qty_dus_rusak | number }} {{ (item.varian_total_in_dus*1) > 1 ? 'Dus' : 'Pcs' }}
                          </div>
                        </td>
                        
                        <!-- <td :style="((item.nominal*1) + (item.nominal_sp2b*1)) === (item.realisasi*1) ? '' : 'background: #FFCDD2;'" style="font-size: 12px; border: 1px solid #ededed; border-left: none; min-width: 150; max-width: 150px; padding: 8px 12px; text-align: left;">{{ (item.realisasi*1) | price }}</td> -->
                        <!-- <td :style="((item.nominal*1) + (item.nominal_sp2b*1)) === (item.realisasi*1) ? '' : 'background: #FFCDD2;'" style="font-size: 12px; border: 1px solid #ededed; border-left: none; width: 150px; min-width: 150; max-width: 150px; padding: 8px 12px; text-align: left;">
                          {{ ((item.nominal*1) + (item.nominal_sp2b*1)) === (item.realisasi*1) ? '' :((item.nominal*1) + (item.nominal_sp2b*1)) > (item.realisasi*1) ? '-' : '+'}}
                          {{ (((item.nominal*1) + (item.nominal_sp2b*1)) - (item.realisasi*1)) | price }}
                        </td> -->
                      </tr>
                    </table>
                  </div>
  
                  <v-card-text
                    v-if="process.load" 
                    class="pb-0 my-4" 
                    style="height: calc(100vh - 350px); display: flex; align-items: center; justify-content: center;">
                    <div class="text-center">
                      <div class="mb-4 title">
                        Mohon Tunggu . . .
                      </div>
  
                      <v-progress-linear
                        :color="set_color"
                        indeterminate
                        rounded
                        height="10">
                      </v-progress-linear>
                    </div>
                  </v-card-text>
  
                  <v-card-text
                    v-if="varian.length === 0 && !process.load"
                    class="pb-0 my-4" style="height: calc( 100vh - 350px ); display: flex; align-items: center; justify-content: center;">
                    <div class="text-center">
                      <v-img 
                        class="mx-auto"
                        contain
                        alt="vuetify"
                        :width="90"
                        :height="90"
                        :src="require('@/assets/image/empty.png')">
                      </v-img>
                      <div class="mt-3 fs-16">
                        Belum Ada Data
                      </div>
                    </div>
                  </v-card-text>
                </div>
              </v-card>
          </v-card>
        </section>
        <section>
          <v-row
            justify="end"
            class="pa-4 pr-1">
            <v-col 
              cols="12"
              md="12"
              class="d-flex align-center justify-end py-0">

              <!-- <v-btn 
                @click="dialog.status = true; message.error = ''; detail.status == 'Set Order' ? status = 'diterima driver' : detail.status == 'diterima driver' ? status = 'pengiriman' : status = 'diterima customer'"
                :loading="process.load"
                :disabled="process.load"
                v-if="detail.status !== 'diterima customer'"
                width="150"
                height="45"
                elevation="0"
                color="#1814F3"
                class="fs-16 white--text text-capitalize border-radius">
                Ubah Status
              </v-btn> -->
              
              <v-btn
                to="/delivery/bpb"
                color="red"
                elevation="0"
                width="140"
                height="45"
                class="body-2 white--text text-capitalize d-flex align-center ml-4 border-radius"
                style="font-weight: 600;">
              
                  Kembali
              </v-btn>
            </v-col>
          </v-row>
        </section>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import { TokenService } from "@/service/Storage.Service";
  import { get, post, put, patch, destroy } from "@/service/Axios";
  import axios from "axios";
  import moment from "moment"
  import "moment/locale/id"
  export default {
    data () {
      return {
        approved_by: [],
        approved_reason: '',
        date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
        menu: false,
        modal: false,
        menu2: false,
        
        zoomed: false,
        zoomedTtd: false,
        imageAspectRatio: 1,
        imageAspectRatioTtd: 1,

        dialog: {
          status: false
        },
        status: '',

        detail: {},
        varian: [],

        rejected_reason: '',

        form: {
          id: '',
          sales_id: '',
          name_alias: '',
          name: '',
          mobilephone_arr: [],
          email: '',
          nik: '',
          npwp: '',
          plafon: '',
          faktur: '',
          term: '',
          ttd: ''
        },
        category: [],
        branch: [],

        mobilephone: {
          name: '',
          id: ''
        },

        upload: {
          ttd: null,
          image_url: null
        },

        selected: {
          row: -1
        },

        process: {
          form: false,

          load: false,

          image_url: false,
          export: false
        },
        
        message: {
          success: '',
          error: '',
          status: ''
        }
      }
    },
    components: {
      uploadfolder: () => import(/* webpackPrefetchCategory: true */ '@/components/upload/folder.vue')
    },
    watch: {
      
    },
    computed: {
      user () {
        return this.$store.state.user
      },
      rps () {
        return this.$vuetify.breakpoint.name
      },
      fcm () {
        return this.$store.state.fcm
      },
      isDay () {
        let hours = (new Date()).getHours(),
            day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
        return day
      },
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.97)`
      },
      set_color_rgb_up () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g+30}, ${b+30}, 0.97)`
      },
      set_color_rgb_down () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.25)`
      }
    },
    mounted () {
      this.fetchList()
    },
    methods: {
      async fetchList () {
        this.process.load = true
        let params = {
          id: this.$route.params.id
        }

        await get('admin/bpb/data', { params })
        .then(response => {
          let res = response.data
            
          if (res.status === 200) {
            this.detail = res.results.data[0]
            this.fetchDetail()
          }
          // this.process.load = false
        })
      },
      async fetchDetail () {
        this.process.load = true
        let params = {
          bpb_id: this.$route.params.id
        }

        await get('admin/bpb/detail', { params })
        .then(response => {
          let res = response.data
            
          if (res.status === 200) {
            this.varian = res.results.data.data
          }
          this.process.load = false
        })
      },
      reset (index) {
        if (this.$refs.form) this.$refs.form.reset()
        
        this.rejected_reason = ''

        this.process.form = false

        this.message.error = ''
      },
      onImageLoad(e) {
        const img = e.target
        this.imageAspectRatio = img.naturalWidth / img.naturalHeight
      },
      onImageLoadAkta(e) {
        const img = e.target
        this.imageAspectRatioAkta = img.naturalWidth / img.naturalHeight
      },

      async save () {
        this.message.error = ''
        const isValid = true
        if (isValid) {
          

        this.process.form = true

        await post(`admin/delivery/update_status_driver`, {
          data: {
            id: this.detail.id,
            status: this.status,
          }
        }).then(response => {
          let res = response.data

          this.process.form = false

          if (res.status === 200) {

            this.dialog.status = false

            
            this.dialog.snackbar = true
            this.message.success = res.message

            this.dialog.fullscreen = false

            this.fetchDetail()
          } else {
            this.message.error = res.message
          }
        })
          
        } else {
          // AUTO FOCUS ON TEXT-FIELD
          setTimeout(() => {
            const errors = Object.entries(this.$refs.form.errors)
              .map(([key, value]) => ({ key, value }))
              .filter(error => error['value'].length)
            this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            })
          }, 10)
        }

        
      },

      async exports (id) {
        this.message.error = ''

        this.process.export = true

        let params = {
          bpb_id: id
        }

        await axios({
          url: `${process.env.VUE_APP_API_URL}admin/bpb/export_pdf`,
          method: 'GET',
          responseType: 'blob', // important,
          params: params,
          headers: {
            Authorization: process.env.VUE_APP_XAUTH,
            token: TokenService.getToken()
          }
        }).then((response) => {
          let res = response

          this.process.export = false
          console.log(res.headers)
          let disposition = res.headers['content-disposition']
          // console.log(disposition)
          var fileName = res.headers['content-disposition'].split('filename=\"')[1]
          let filename = ''

          if (disposition && disposition.indexOf('inline') !== -1) {
            var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
            var matches = filenameRegex.exec(disposition);
            if (matches != null && matches[1]) { 
              filename = matches[1].replace(/['"]/g, '');
            }
          }
          // console.log(filename)

          if (res.status === 200) {
            this.dialog.snackbar = true
            this.message.success = 'Berhasil mengeksport pdf'

            const url = window.URL.createObjectURL(new Blob([response.data]))
            const link = document.createElement('a')
            link.href = url

            link.setAttribute('download', filename)
            document.body.appendChild(link)

            link.click()
          } else {
            this.message.error = res.message
          }
        })
      }
    }
  }
</script>

<style>
    /* ::-webkit-scrollbar {
      width: 10px;
      height: 10px;
      background-color: #F5F5F5;
    }
    ::-webkit-scrollbar-track{
      background-color: #F5F5F5;
      border-radius: 10px;
    } */
    ::-webkit-scrollbar-thumb{
      border-radius: 10px;
      background-color: #718EBF;
    }
    table, th, td {
      /* border: 1px solid #ededed;
      border-collapse: collapse; */
      /* border: thin ridge black; */
      border-spacing: 4px;
      border-collapse: collapse;
    }
  
    .view {
      margin: auto;
      /* width: 100%; */
    }
  
    .wrapper-laporan-faktur { 
      overflow-y: auto; 
      height: calc(100vh - 290px); 
    } 
  
    .wrapper-laporan-faktur-none { 
      /* overflow-y: auto; 
      height: calc(100vh - 270px);  */
    } 
  
    .wrapper-laporan-faktur th { 
      position: sticky; 
      top: 0; 
      background-color: white !important;
    } 
    .sticky-col {
      position: -webkit-sticky;
      position: sticky;
      background-color: white !important;
    }
  
    .one-col {
      width: 150px;
      min-width: 150px;
      max-width: 150px;
      left: 0px;
    }
  
    .second-col-detail-faktur {
      width: 100px;
      min-width: 100px;
      max-width: 100px;
      left: 60px;
    }
  
    .three-col {
      width: 150px;
      min-width: 150px;
      max-width: 150px;
      left: 300px;
    }
  
    .four-col {
      width: 200px;
      min-width: 200px;
      max-width: 200px;
      left: 450px;
    }
  
    tr:hover {background-color: #1976d236;}
    tr.selected {background-color: #1976d236;}
  
    .border-radius-card-8 {
      border-radius: 8px;
    }
  </style>